import PropTypes from 'prop-types'
import { DialogContent } from '@mui/material'

import { SIZES } from '@hapana/shared/web/components/shared/dialog/dialog-layout/dialog-layout.constants'
import { useDialog } from '@hapana/shared/web/components/shared/dialog/dialog.hooks'
import { useActiveExportRequests } from '_pages/exports/exports.hooks'
import Dialog from '@hapana/shared/web/components/shared/dialog/dialog.component'

import { styles } from './export-request-mobile.styles'
import ExportRequestList from './export-request-list.component.jsx'
import { EXPORT_STATUS } from './export-widgets.constants'

const MobileRequestMobile = ({ onRemoveRequest, onClearRequestHistory }) => {
  const { dialogState, setDialogState } = useDialog()

  const {
    data: activeRequests,
    isLoading,
    isRefetching,
  } = useActiveExportRequests({
    onSuccess: (data) => {
      setDialogState({
        requestHistory: data
          .filter(({ status }) => status === EXPORT_STATUS.processed)
          .reduce((acc, curr) => {
            acc[curr.id] = curr
            return acc
          }, {}),
      })
    },
  })

  const { requestHistory, idsLoading } = dialogState

  return (
    <Dialog closeType={null} size={SIZES.XS} hasMobileBottomSheet sx={styles.root}>
      <DialogContent sx={styles.dialogContent}>
        <ExportRequestList
          activeRequests={activeRequests}
          requestHistory={requestHistory}
          idsLoading={idsLoading}
          isLoading={isLoading || isRefetching}
          onRemoveRequest={onRemoveRequest}
          onClearRequestHistory={onClearRequestHistory}
        />
      </DialogContent>
    </Dialog>
  )
}

MobileRequestMobile.propTypes = {
  onRemoveRequest: PropTypes.func.isRequired,
  onClearRequestHistory: PropTypes.func.isRequired,
}

MobileRequestMobile.defaultValues = {}

export default MobileRequestMobile
